import * as Yup from "yup";

const name = Yup.string("Please specify a name")
  .min(3, "Name must be at least 3 characters")
  .required("Please specify a name");

export default name;
